module.exports = __webpack_public_path__ + "static/media/ios-bed.edf7025d.svg";